import { gql } from "urql";
export const GetLocationCountQuery = gql `
    query GetLocationCount($search: String, $organizationId: String) {
        locations {
            locationCount(search: $search, organizationId: $organizationId)
        }
    }
`;
export const GetLocationsQuery = gql `
    query GetLocations(
        $search: String
        $offset: Int
        $organizationId: String
    ) {
        locations {
            locations(
                search: $search
                offset: $offset
                organizationId: $organizationId
            ) {
                locationId
                organizationId
                name
                address1
                address2
                city
                stateId
                stateName
                postalCode
                isPrimary
                isActive
                imageUrl
                createdAt
                updatedAt
            }
        }
    }
`;
export const GetLocationQuery = gql `
    query GetLocation($locationId: String!, $organizationId: String) {
        locations {
            location(locationId: $locationId, organizationId: $organizationId) {
                locationId
                organizationId
                organizationName
                name
                address1
                address2
                city
                stateId
                stateName
                postalCode
                latitude
                longitude
                isPrimary
                isActive
                imageUrl
            }
        }
    }
`;
export const GetLocationListQuery = gql `
    query GetLocationList($organizationId: String) {
        locations {
            locationsList(organizationId: $organizationId) {
                value
                label
            }
        }
    }
`;
export const GetLocationPostalCodesQuery = gql `
    query GetLocationPostalCodes {
        locations {
            locations {
                locationId
                postalCode
            }
        }
    }
`;
